export default [
  {
    path: "/",
    name: "default",
    meta: { title: "Projects list", authRequired: true },
    component: () => import("../views/projects/projects-list")
  },
  {
    path: "/login",
    name: "login",
    meta: { title: "Login" },
    component: () => import("../views/account/login")
  },
  {
    path: "/logout",
    name: "logout",
    meta: { title: "Logout", authRequired: true },
    component: () => import("../views/account/logout")
  },
  {
    path: "/workspaces/new",
    name: "workspaces.create",
    meta: { title: "Create workspace", authRequired: true },
    component: () => import("@/views/workspaces/CreateNew.vue"),
  },
  {
    path: "/projects",
    name: "Projects list",
    meta: { title: "Projects list", authRequired: true },
    component: () => import("../views/projects/projects-list")
  },
  {
    path: "/project/:project_code",
    name: "Project Card",
    meta: { title: "Project card", authRequired: true },
    component: () => import("../views/projects/project-card")
  },
  {
    path: "/project/:project_code/dashboard",
    name: "Project Dashboard",
    meta: { title: "Project Dashboard", authRequired: true },
    component: () => import("../views/content/ProjectDashboard")
  },
  {
    path: "/project/:project_code/collection/:collection_code",
    name: "Collection Card",
    meta: { title: "Collection card", authRequired: true },
    component: () => import("../views/collections/collection-card.vue")
  },
  {
    path: "/project/:project_code/collection/:collection_code/content",
    name: "Collection Entries",
    meta: { title: "Collection Entries", authRequired: true },
    component: () => import("../views/content/CollectionContent.vue")
  },
  {
    path: "/project/:project_code/collection/:collection_code/entries",
    name: "Collection new entry",
    meta: { title: "Collection entries", authRequired: true },
    component: () => import("../views/collections/form/form.vue")
  },
  {
    path: "/project/:project_code/collection/:collection_code/entries/:entry_uuid",
    name: "Edit Collection Entry",
    meta: { title: "Edit Collection Entry", authRequired: true },
    component: () => import("../views/collections/form/form.vue")
  },
  {
    path: "/project/:project_code/collection/:collection_code/template/:template_uuid",
    name: "Template Edit",
    meta: { title: "Edit Template", authRequired: true },
    component: () => import("../views/collections/template-edit.vue")
  },
  {
    path: "/project/:project_code/block/:block_code",
    name: "Block Card",
    meta: { title: "Block card", authRequired: true },
    component: () => import("../views/blocks/block-card.vue")
  },
  {
    path: "/project/:project_code/block/:block_code/content",
    name: "Block Content",
    meta: { title: "Block Content", authRequired: true },
    component: () => import("../views/content/BlockContent.vue")
  },
  {
    path: "/project/:project_code/files",
    name: "Files",
    meta: { title: "Files", authRequired: true },
    component: () => import("../views/content/FilesContent.vue")
  },
  {
    path: "/project/:project_code/redirects",
    name: "Redirects",
    meta: { title: "Redirects", authRequired: true },
    component: () => import("../views/redirects/RedirectsList.vue")
  },
  {
    path: "/project/:project_code/robots-txt",
    name: "RobotsTxt",
    meta: { title: "Robots.txt", authRequired: true },
    component: () => import("../views/robotstxt/RobotsTxt.vue")
  },
  {
    path: "/project/:project_code/sitemap",
    name: "Sitemap",
    meta: { title: "Sitemap", authRequired: true },
    component: () => import("../views/sitemap/SitemapList.vue")
  },
  {
    path: "/project/:project_code/audit-log",
    name: "AuditLog",
    meta: { title: "Dziennik zdarzeń", authRequired: true },
    component: () => import("../views/audit/AuditList.vue")
  },
  {
    path: "/project/:project_code/menu/:menu_code",
    name: "Menu Card",
    meta: { title: "Menu card", authRequired: true },
    component: () => import("../views/menus/menu-card.vue")
  },
  {
    path: "/project/:project_code/menu/:menu_code/content",
    name: "Menu Content",
    meta: { title: "Menu Content", authRequired: true },
    component: () => import("../views/content/MenuContentEditor.vue")
  },
  {
    path: "/project/:project_code/:entity/:entity_code/field/:field_code",
    name: "Field Card",
    meta: { title: "Field Card", authRequired: true },
    component: () => import("../views/fields/field-card.vue")
  },
  {
    path: "/project/:project_code/:entity/:entity_code/field/:field_code/option/:option_code",
    name: "Field option card",
    meta: { title: "Field option card", authRequired: true },
    component: () => import("../views/options/option-card.vue")
  },
  {
    path: "/project/:project_code/page/:page_code",
    name: "Page Card",
    meta: { title: "Page card", authRequired: true },
    component: () => import("../views/pages/page-card.vue")
  },
  {
    path: "/project/:project_code/page/:page_code/content",
    name: "Page Content",
    meta: { title: "Page Content", authRequired: true },
    component: () => import("../views/content/PageContent.vue")
  },
  {
    path: "/project/:project_code/page/:page_code/simple-content",
    name: "Simple Page Content",
    meta: { title: "Simple Page Content", authRequired: true },
    component: () => import("../views/content/SimplePageContent.vue")
  },
  {
    path: "/project/:project_code/element/:element_code",
    name: "Element Card",
    meta: { title: "Element card", authRequired: true },
    component: () => import("../views/elements/element-card.vue")
  },
  {
    path: "/project/:project_code/element/:element_code/content",
    name: "Element Content",
    meta: { title: "Element Content", authRequired: true },
    component: () => import("../views/content/ElementContent.vue")
  },
  {
    path: "/project/:project_code/forms",
    name: "Forms List",
    meta: { title: "Forms", authRequired: true },
    component: () => import("../views/forms/FormList.vue")
  },
  {
    path: "/project/:project_code/form/:form_code",
    name: "Form Card",
    meta: { title: "Edit Form", authRequired: true },
    component: () => import("../views/forms/FormCard.vue")
  },
  {
    path: "/project/:project_code/form/:form_code/submissions",
    name: "Form Submissions",
    meta: { title: "Form Submissions", authRequired: true },
    component: () => import("../views/forms/FormSubmissions.vue")
  },
  {
    path: "/project/:project_code/schemas",
    name: "Schemas List",
    meta: { title: "Content Schemas", authRequired: true },
    component: () => import("../views/schemas/SchemaList.vue")
  },
  {
    path: "/project/:project_code/schema/:schema_code",
    name: "Schema Card",
    meta: { title: "Schema Card", authRequired: true },
    component: () => import("../views/schemas/SchemaCard.vue")
  },
  {
    path: "/project/:project_code/schema/:schema_code/field/:field_code",
    name: "Schema Field Card",
    meta: { title: "Schema Field Card", authRequired: true },
    component: () => import("../views/fields/field-card.vue")
  },
  {
    path: "/project/:project_code/schema/:schema_code/field/:field_code/option/:option_code",
    name: "Schema Field option card",
    meta: { title: "Schema Field option card", authRequired: true },
    component: () => import("../views/options/option-card.vue")
  },
  {
    path: "/users",
    name: "Users list",
    meta: { title: "Users list", authRequired: true, requiresWorkspaceAdmin: true },
    component: () => import("../views/users/users-list")
  },
  {
    path: "/settings",
    name: "Workspace Settings",
    meta: { title: "Workspace Settings", authRequired: true, requiresWorkspaceAdmin: true },
    component: () => import("../views/workspaces/SettingsView.vue")
  },
  {
    path: "/user/settings",
    name: "Settings",
    meta: { title: "Settings", authRequired: true },
    component: () => import("../views/settings/SettingsCard.vue")
  },
  {
    path: "/subscriptions",
    name: "Subscriptions",
    meta: { title: "Subscriptions", authRequired: true, requiresWorkspaceAdmin: true },
    component: () => import("../views/subscriptions/subscription-cart")
  },
  {
    path: '/auth/callback',
    name: 'sso-callback',
    component: () => import('@/views/account/sso-callback.vue'),
    meta: { title: "SSO Callback", guestOnly: true }
  },
  {
    path: "/workspaces",
    name: "workspaces",
    component: () => import("@/views/workspaces/Select.vue"),
    meta: { requiresAuth: true }
  }

  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  // {
  //   path: "*",
  //   redirect: "404",
  // },

];
